import { render, staticRenderFns } from "./ListVamRequests.vue?vue&type=template&id=4bfbff08&scoped=true&"
import script from "./ListVamRequests.vue?vue&type=script&lang=js&"
export * from "./ListVamRequests.vue?vue&type=script&lang=js&"
import style0 from "./ListVamRequests.vue?vue&type=style&index=0&id=4bfbff08&scoped=true&lang=css&"
import style1 from "./ListVamRequests.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbff08",
  null
  
)

export default component.exports